module.exports = __webpack_public_path__ + "img/ch6.65dac090.png";